import React from 'react';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarIcon from '@material-ui/icons/Star';
import { Button, Grid, makeStyles } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
	Btn: {
		backgroundColor: 'gold',
	},
}));
const PrimaryModelBtn = ({ isPrimary, onClick }) => {
	const classes = useStyles();
	const handleClick = () => {
		onClick(!isPrimary);
	};
	const icon = isPrimary ? <StarIcon /> : <StarBorderIcon />;
	const text = isPrimary ? 'Primary Model' : 'Set as Primary Model';
	return (
		<Grid>
			<Button
				color="primary"
				variant="outlined"
				size="large"
				endIcon={icon}
				className={classes.Btn}
				onClick={handleClick}
			>
				{text}
			</Button>
		</Grid>
	);
};

export default PrimaryModelBtn;
